import React, { useEffect, useState } from "react";
import {
  SearchIcon,
  IncomingIcon,
  CompletedIcon,
  RejectedIcon,
  PendingIcon,
} from "../../../assets/svgs/Icons";
import { FiFilter } from "react-icons/fi";
import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  InputGroup,
  InputLeftElement,
  Skeleton,
  Tab,
  Table,
  TableCaption,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Badge,
  Tabs,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  Link,
  Select,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  Column,
  useReactTable,
  ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel,
  sortingFns,
  getSortedRowModel,
  FilterFn,
  SortingFn,
  ColumnDef,
  flexRender,
  FilterFns,
  createColumnHelper,
} from "@tanstack/react-table";
import { rankItem } from "@tanstack/match-sorter-utils";
import moment from "moment/moment";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";
import { getAllTCs } from "./TCL2AdminSlice";

const IncomingTC = () => {
  const [status, setStatus] = useState("idle");
  const [columnFilters, setColumnFilters] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const TCStatus = "INCOMING";
  const TcStage = "L2-TC-ISSUER";
  const dispatch = useDispatch();
  const { allTCs, isloading } = useSelector((state) => state.TCL2Admin);

  const navigate = useNavigate();

  const getList = async () => {
    try {
      setIsDataLoading(true);
      setStatus("pending");
      const result = dispatch(getAllTCs({ TCStatus, TcStage }));
      unwrapResult(result);
      setStatus("success");
      setIsDataLoading(false);
    } catch (error) {
      setStatus("failed");
    }
  };

  const updateIncomingData = () => {
    const updatedData = allTCs?.map((d, index) => {
      return {
        ...d,
        srNo: index + 1,
        actions: "actions",
        dateTime: `${moment(d?.createdAt)?.format("DD-MM-YYYY")}`,
        assign_action: "assign_action",
      };
    });

    setUpdatedData(updatedData);
  };

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("srNo", {
      cell: (info) => info.getValue(),
      header: "srNo",
    }),
    columnHelper.accessor("dateTime", {
      cell: (info) => info.getValue(),
      header: "Date",
      sortType: (a, b) => {
        var a1 = new Date(a).getTime();
        var b1 = new Date(b).getTime();
        if (a1 < b1) return 1;
        else if (a1 > b1) return -1;
        else return 0;
      },
    }),
    columnHelper.accessor("tcApplicationNumber", {
      cell: (info) => info.getValue(),
      header: "Application Number",
    }),
    columnHelper.accessor("tc_seller.name", {
      cell: (info) => info.getValue(),
      header: "Seller Organization",
      // meta: {
      //   isNumeric: true,
      // },
    }),
    columnHelper.accessor("", {
      cell: (info) => {
        const buyerName = info.row.original.buyerDetails?.name;
        return (
          <Badge colorScheme={buyerName ? "red" : "green"}>
            {buyerName ? "Unregistered" : "Registered"}
          </Badge>
        );
      },
      header: "Buyer Type",
    }),
    columnHelper.accessor("tc_program.name", {
      cell: (info) => info.getValue(),
      header: "Certification Name",
      // meta: {
      //   isNumeric: true,
      // },
    }),
    columnHelper.accessor("totalGrossWeight", {
      cell: (info) => info.getValue(),
      header: "Gross Weight (Kg)",
      // meta: {
      //   isNumeric: true,
      // },
    }),
    columnHelper.accessor("totalNetWeight", {
      cell: (info) => info.getValue(),
      header: "Net Weight (Kg)",
      // meta: {
      //   isNumeric: true,
      // },
    }),
    columnHelper.accessor("totalCertifiedWeight", {
      cell: (info) => info.getValue(),
      header: "Certified Weight (Kg)",
      // meta: {
      //   isNumeric: true,
      // },
    }),

    columnHelper.accessor("actions", {
      Cell: ({ cell }) => console.log({ cell }),
      header: "Actions",
      // meta: {
      //   isNumeric: true,
      // },
    }),
  ];
  const fuzzyFilter = (row, columnId, value, addMeta) => {
    // Rank the item
    const itemRank = rankItem(row.getValue(columnId), value);
    // Store the itemRank info
    addMeta({
      itemRank,
    });
    // Return if the item should be filtered in/out
    return itemRank.passed;
  };

  const table = useReactTable({
    data: updatedData || [],
    columns,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      columnFilters,
      globalFilter,
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    // Disable "Creating Table Instance" message
    debugTable: false,
    debugHeaders: false,
    debugColumns: false,
  });

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    updateIncomingData();
  }, [allTCs]);

  return (
    <Box>
      {allTCs?.length > 0 ? (
        <>
          <Flex
            gap={"20"}
            alignItems={"center"}
            justifyContent={"space-between"}
          ></Flex>

          <Box marginTop={"3rem"}>
            <Flex mb="1rem" flexDirection={"row"}>
              <Text> TC L2 Admin/ </Text>
              <Text fontWeight={"bold"}>Incoming Applications</Text>
            </Flex>
            <Flex justifyContent="space-between" alignItems="center">
              <Box>
                <InputGroup>
                  <InputLeftElement
                    height={"100%"}
                    pointerEvents="none"
                    children={<SearchIcon color="#B8DEF8" />}
                  />
                  <Input
                    type="text"
                    color={"#464C64"}
                    bg={"#fff"}
                    w={"500px"}
                    h={"48px"}
                    value={globalFilter ?? ""}
                    placeholder="Search All Results"
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    fontSize={"14px"}
                    borderRadius={"10px"}
                    _placeholder={{
                      opacity: 1,
                      color: "#464C64",
                      fontSize: "14px",
                    }}
                  />
                </InputGroup>
              </Box>
              <Box>
                <Box display={"flex"} justifyContent="space-between">
                  <Box>
                    <Box
                      display={"flex"}
                      alignItems="center"
                      marginBottom={"10px"}
                    >
                      <Box
                        as="span"
                        display="flex"
                        alignItems="center"
                        gap="5px"
                        marginRight={"10px"}
                      >
                        <Box as="span" width={"30%"}>
                          {" "}
                          Go to page:{" "}
                        </Box>
                        <Input
                          w={"60%"}
                          type="number"
                          color={"#464C64"}
                          bg={"#fff"}
                          defaultValue={
                            table.getState().pagination.pageIndex + 1
                          }
                          onChange={(e) => {
                            const page = e.target.value
                              ? Number(e.target.value) - 1
                              : 0;
                            table.setPageIndex(page);
                          }}
                        />
                      </Box>
                      <Box>
                        <Select
                          bg="#fff"
                          value={table.getState().pagination.pageSize}
                          onChange={(e) => {
                            table.setPageSize(Number(e.target.value));
                          }}
                        >
                          {[10, 20, 30, 40, 50].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                              Show {pageSize}
                            </option>
                          ))}
                        </Select>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Flex>
          </Box>
          <Box marginTop={"2rem"}>
            <Box
              as="span"
              display="flex"
              alignItems="center"
              marginBottom={"10px"}
              gap="5px"
            >
              <div>Page</div>
              <strong>
                {table?.getState().pagination?.pageIndex + 1} of{" "}
                {table?.getPageCount()}
              </strong>
            </Box>
            <Tabs size="md" variant="enclosed">
              <TableContainer className="overflow-style" overflowX={"scroll"}>
                <Table bg="brand.white" borderRadius="15px">
                  <Thead fontStyle={"normal"}>
                    {table.getHeaderGroups().map((headerGroup) => (
                      <Tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => {
                          // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                          const meta = header.column.columnDef.meta;
                          return (
                            <Th
                              key={header.id}
                              color="brand.blue"
                              textTransform="capitalize"
                              onClick={header.column.getToggleSortingHandler()}
                              isNumeric={meta?.isNumeric}
                            >
                              {flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                              <Box as="span" pl="1rem">
                                {/* {console.log({
                                sort: header.column.getIsSorted(),
                              })} */}
                                {header.column.getIsSorted() ? (
                                  header.column.getIsSorted() === "desc" ? (
                                    <TriangleDownIcon
                                      aria-label="sorted descending"
                                      color={"#3958DC"}
                                      size="20"
                                    />
                                  ) : (
                                    <TriangleUpIcon
                                      aria-label="sorted ascending"
                                      color={"#3958DC"}
                                      size="20"
                                    />
                                  )
                                ) : null}
                              </Box>
                            </Th>
                          );
                        })}
                      </Tr>
                    ))}
                  </Thead>
                  <Tbody>
                    {isloading ? (
                      <>
                        <Tr>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                          <Td>
                            <Skeleton height="20px" fadeDuration={1} />
                          </Td>
                        </Tr>
                      </>
                    ) : (
                      <>
                        {table.getRowModel()?.rows?.map((row) => (
                          <Tr key={row?.id}>
                            {row.getVisibleCells().map((cell) => {
                              // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                              const meta = cell?.column?.columnDef?.meta;
                              return (
                                <Td
                                  key={cell?.id}
                                  isNumeric={meta?.isNumeric}
                                  fontWeight={500}
                                  fontSize="sm"
                                  style={{
                                    maxWidth: "250px",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {cell?.renderValue() === "actions" ? (
                                    <Link
                                      color={"#3958DC"}
                                      fontWeight="800"
                                      onClick={() =>
                                        navigate(
                                          `./tc-details/${encodeURIComponent(
                                            cell?.row?.original?.id
                                          )}`
                                        )
                                      }
                                    >
                                      View Details
                                    </Link>
                                  ) : cell?.renderValue() ===
                                    "assign_action" ? (
                                    <Button
                                    // color={"#3958DC"}
                                    // fontWeight="800"
                                    // onClick={() =>
                                    //   assignToMe(
                                    //     encodeURIComponent(cell?.row?.original?.id)
                                    //   )
                                    // }
                                    >
                                      Assign To Me
                                    </Button>
                                  ) : (
                                    flexRender(
                                      cell?.column?.columnDef?.cell,
                                      cell?.getContext()
                                    )
                                  )}
                                </Td>
                              );
                            })}
                          </Tr>
                        ))}
                      </>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
              <Box
                display={"flex"}
                justifyContent="center"
                marginTop={"1rem"}
                marginBottom="2rem"
              >
                <Box display={"flex"} gap="2rem">
                  <Button
                    className="border rounded p-1"
                    bg="#52BBFF"
                    _hover={{ bg: "#52BBFF" }}
                    onClick={() => table.previousPage()}
                    disabled={!table.getCanPreviousPage()}
                  >
                    <AiOutlineArrowLeft color="#141D43" size={18} />
                  </Button>
                  <Button
                    className="border rounded p-1"
                    bg="#52BBFF"
                    _hover={{ bg: "#52BBFF" }}
                    onClick={() => table.nextPage()}
                    disabled={!table.getCanNextPage()}
                  >
                    <AiOutlineArrowRight color="#141D43" size={18} />
                  </Button>
                </Box>
              </Box>
            </Tabs>
          </Box>
        </>
      ) : (
        <Box
          display={"flex"}
          alignItems="center"
          marginTop={"8rem"}
          justifyContent="center"
        >
          <Text fontSize={"25px"} fontWeight={"bold"} textAlign="center">
            There are no Incoming applications yet
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default IncomingTC;
